export default __webpack_public_path__ + "static/media/cardmarket-logo.78902b4d.svg";